export default "__VITE_ASSET__jLVNx2Lw__"